export const MIN_ZOOM = 0.1;
export const MAX_ZOOM = 10;
export const ZOOM_STEP = 0.1;
export const ZOOM_STEP_WHEEL = 0.00025;
export const MIN_ZOOM_WHEEL = 0.05;
export const MAX_ZOOM_WHEEL = 0.5;
